import React, { useEffect, useRef, useState } from 'react';
import googleIdentityService from '../services/googleIdentityService';
import './GoogleIdentityButton.css';

function GoogleIdentityButton({
  purpose = 'login',
  width = 320,
  className = '',
  onSuccess,
  onError,
}) {
  const targetRef = useRef(null);
  const successRef = useRef(onSuccess);
  const errorRef = useRef(onError);
  const [state, setState] = useState({ loading: true, error: '' });
  const [attempt, setAttempt] = useState(0);

  successRef.current = onSuccess;
  errorRef.current = onError;

  useEffect(() => {
    let active = true;
    let dispose = null;
    setState({ loading: true, error: '' });
    googleIdentityService.renderButton(targetRef.current, {
      purpose,
      width,
      onSuccess: (result) => {
        if (!active) return;
        setState({ loading: false, error: '' });
        if (successRef.current) successRef.current(result);
      },
      onError: (error) => {
        if (!active) return;
        setState({ loading: false, error: error?.message || 'Google 로그인에 실패했습니다.' });
        if (errorRef.current) errorRef.current(error);
      },
    }).then((handle) => {
      dispose = handle?.dispose || null;
      if (active) setState({ loading: false, error: '' });
      else if (dispose) dispose();
    }).catch((error) => {
      if (!active) return;
      setState({ loading: false, error: error?.message || 'Google 로그인이 현재 준비되지 않았습니다.' });
      if (errorRef.current) errorRef.current(error);
    });
    return () => {
      active = false;
      if (dispose) dispose();
    };
  }, [attempt, purpose, width]);

  return (
    <div className={`google-identity-control ${className}`.trim()}>
      <div
        ref={targetRef}
        className="google-identity-button-target"
        aria-busy={state.loading}
        aria-label={purpose === 'link' ? 'Google 계정 연결' : 'Google로 로그인'}
      />
      {state.loading && <span className="google-identity-status">Google 로그인 준비 중...</span>}
      {state.error && (
        <div className="google-identity-error" role="alert">
          <span>{state.error}</span>
          <button type="button" onClick={() => setAttempt((value) => value + 1)}>다시 시도</button>
        </div>
      )}
    </div>
  );
}

export default GoogleIdentityButton;
